<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="480px"
    custom-class="ca-pay-result"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <div slot="title" class="ca-pay-result__title">支付</div>
    <p class="ca-pay-result__tip">
      请您在新打开的网上银行页面进行支付，支付完成前请不要关闭窗口。
    </p>
    <div slot="footer" class="ca-pay-result__footer">
      <el-button class="ca-pay-result__problem-btn" @click="handleProblem">
        支付遇到问题
      </el-button>
      <el-button type="danger" @click="handleDone">已完成支付</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CaPayResultDialog',
  props: {
    visible: { type: Boolean, default: false },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      },
    },
  },
  methods: {
    handleProblem() {
      this.innerVisible = false
      this.$emit('problem')
    },
    handleDone() {
      this.innerVisible = false
      this.$emit('done')
    },
  },
}
</script>
